<div class="">
  <ng-content></ng-content>
  <div class="">
    <app-upload-button
      [disabled]="disabled"
      [visible]="uploadButtonVisible"
      [hasCropper]="hasCropper"
      [aspectRatio]="aspectRatio"
      [storageFolder]="storageFolder"
      [extensions]="fileExtensions"
      [showExtensionInfo]="showExtensionInfo"
      (fileUrl)="onImageLoaded($event)">
    </app-upload-button>
  </div>
</div>
